import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledAboutUsCards = styled(NanoFlex)`
  gap: 24px;
  padding: 0 100px 0 100px;

  .singleCard {
    min-height: 290px;
    height: auto;
    border-radius: 10px;
    background-color: ${(props) => props.theme.color.primaryColors.lightPurple};
    padding: 32px;
    flex: 1 calc(33.33% - 24px);
    width: calc(33.33% - 24px);

    .cardHeader {
      h4 {
        font-weight: 600;
      }
    }

    .cardContent {
      flex-grow: 1;
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;

    .singleCard {
      min-height: 280px;
    }
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px;
    gap: 16px;
    max-width: 100%;
    flex-wrap: wrap;

    .singleCard {
      width: 100%;
      flex: 1 100%;
      padding: 16px;
      min-height: unset;
      height: auto;
      gap: 16px;
      min-height: 216px;
      border-radius: 5px;

      &:first-child {
        width: auto;
        flex: 1 calc(50% - 16px);
      }
      &:nth-child(2) {
        width: auto;
        flex: 1 calc(50% - 16px);
      }

      &:last-child {
        width: 100%;
        flex: 1 100%;
        min-height: auto;
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    flex-direction: column;
    flex-wrap: nowrap;

    .singleCard {
      min-height: unset;
    }
  }
`;

export default class AboutUsCards extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAboutUsCards justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="singleCard" flexDirection="column">
          <NanoFlex className="cardHeader" justifyContent="flex-start">
            <Type.h4 dangerouslySetInnerHTML={{ __html: this.translation.aboutUs.personalizedService }}></Type.h4>
          </NanoFlex>
          <NanoFlex className="cardContent" justifyContent="flex-start" alignItems="flex-end">
            <Type.p>{this.translation.aboutUs.personalizedServiceText}</Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="singleCard" flexDirection="column">
          <NanoFlex className="cardHeader" justifyContent="flex-start">
            <Type.h4 dangerouslySetInnerHTML={{ __html: this.translation.aboutUs.sepecializedTeam }}></Type.h4>
          </NanoFlex>
          <NanoFlex className="cardContent" justifyContent="flex-start" alignItems="flex-end">
            <Type.p>{this.translation.aboutUs.sepecializedTeamText}</Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="singleCard" flexDirection="column">
          <NanoFlex className="cardHeader" justifyContent="flex-start">
            <Type.h4 dangerouslySetInnerHTML={{ __html: this.translation.aboutUs.continuousMonitoring }}></Type.h4>
          </NanoFlex>
          <NanoFlex className="cardContent" justifyContent="flex-start" alignItems="flex-end">
            <Type.p>{this.translation.aboutUs.continuousMonitoringText}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledAboutUsCards>
    );
  }
}
